
import HeightTween from 'vue-height-tween-transition'
import { padNum } from '/services/helpers'
export default
	props: block: Object
	# CSS transition delay not working, so setting a delay for the button transition with JavaScript
	data: -> active: 0, delayedActive: 0
	components: { HeightTween }
	computed:
		isOneColumn: -> @block.accordionColumns.length == 1
		classes: -> [
			@block.maxWidth || "max-w-wide-indented"
			"one-column" if @isOneColumn
			'has-headline' if !!@block.headline
		]

	watch: active: (active) -> setTimeout(
		() => @setDelayedActive(active),
		600
	)

	methods:
		padNum: padNum
		select: (index) -> @active = index
		setDelayedActive: (index) -> @delayedActive = index
		paneHasImage: (pane) -> if Array.isArray pane.image then !!pane.image.length else !pane.image

